import { ICondition } from "../../core/src/states/State";
import VendorModel from "../../server/model/VendorModel";

export default class AwardedFreeGamesCondition implements ICondition {
    check():boolean {
        return VendorModel.freeGames!=null && VendorModel.freeGames != undefined;
    }

}